module.exports = __webpack_public_path__ + "svg/symfony.49b828.svg";